import React, { Suspense, lazy } from 'react';
import { modifyData } from '../LoyaltyCrmUtilities/loyaltyCrmUtils';
import { SIGNME_UP_BANNER_CONTAINER, LOYALTY_CRM_ITEMS } from 'common/constants/SharedConstants';
import { isSupportedTenantCode } from 'common/utilities/utils';

export const LoyaltyCrmContainer = props => {
  const { contentData } = props;
  const loyaltyData = contentData && modifyData(contentData);

  const getComponentName = isSupportedTenantCode() ? SIGNME_UP_BANNER_CONTAINER : LOYALTY_CRM_ITEMS;

  const SignMeUPBannerTemplate = lazy(() =>
    import('organisms/LoyaltyCrmSignupComponent/Presentation/' + getComponentName),
  );

  return (
    <Suspense fallback={<div>Loding...</div>}>
      {' '}
      <SignMeUPBannerTemplate contentData={loyaltyData} customTag={props.customTag} />{' '}
    </Suspense>
  );
};

export default LoyaltyCrmContainer;
